import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const RetractableBanners = () => {

    const servicesFaqData = [
        {
            question: "What are retractable banners, and how can they be used?",
            answer: "Retractable banners, or roll-up standees, are portable and self-standing displays ideal for events, trade shows, retail promotions, and corporate presentations. Their lightweight design and easy setup make them highly versatile."
        },
        {
            question: "What is included in Printingy’s standee design price?",
            answer: "Our standee design price includes customised layouts, graphics, and text that align with your branding. We ensure high-resolution visuals and precise printing to deliver professional and eye-catching results."
        },
        {
            question: "How affordable is the standee printing price for bulk orders?",
            answer: "Printingy offers competitive standee printing prices for bulk orders. Larger volumes significantly reduce per-unit costs, providing an economical solution for businesses requiring multiple retractable banners or standees."
        },
        {
            question: "What materials are used for roll-up standee printing?",
            answer: "We use premium-quality vinyl or fabric materials for roll-up standee printing. These materials are durable, fade-resistant, and designed to maintain sharp visuals even with prolonged use."
        },
        {
            question: "Can I customise the design for my retractable banners?",
            answer: "Yes, Printingy offers fully customisable options for printing standees and banners. You can include logos, brand messaging, product visuals, and vibrant colours to create an impactful design tailored to your business needs."
        },
        {
            question: "How long does it take to print bulk retractable banners?",
            answer: "The turnaround time for Printing Retractable Banners depends on the order size and design complexity. Standard bulk orders are typically completed within a few business days, with expedited options available for urgent projects."
        },
        {
            question: "What industries benefit from retractable banners?",
            answer: "Industries such as retail, events, hospitality, education, and corporate sectors rely on printing standees and retractable banners for advertising, product displays, and promotional campaigns."
        },
        {
            question: "Are retractable banners reusable?",
            answer: "Yes, our retractable banners are designed for reusability. Durable materials and easy-to-store mechanisms can be rolled up and reused for multiple events without compromising quality."
        },
        {
            question: "What makes roll-up standees ideal for promotions?",
            answer: "Roll-up standee printing offers a professional, portable solution for showcasing products, services, or messages. Their quick setup and visual appeal make them ideal for events, trade shows, and retail spaces."
        },
        {
            question: "How do I place an order for custom retractable banners?",
            answer: "To order custom retractable banner printing, visit our website, choose your specifications, and upload your artwork. Our team will assist with design approvals and ensure timely delivery."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Printing of Retractable Banners');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Retractable Banners and Standees Printing Services"
  description="Professional printing of retractable, standees, and roll-up banners. Bulk standee printing price and custom standee design price for businesses."
  keywords="Printing of Retractable Banners,
Printing of Standees,
Standee Printing Price,
Standee Design Price,
Roll-up Standee Printing"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Retractable Banners</h1>
              <h2 className="text-muted">
              Custom roll-up banners and standees for events and promotions
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Retractable banners, also known as standees or roll-up banners, are essential for events, trade shows, and promotions due to their portability, professional look, and impact. Printingy specialises in the Printing of Retractable Banners, offering high-quality printing of standees and roll-up standee printing services.</p>
          <p>Our solutions include tailored designs and cost-effective bulk options, with competitive standee printing and standee design prices to suit your business requirements. Whether you need banners for exhibitions, product launches, or in-store promotions, we deliver durable, lightweight, and easy-to-set-up retractable banners.</p>
          <p>With precision printing and premium materials, Printingy ensures that your banners stand out with sharp visuals and vibrant colours.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable and Custom Retractable Banners Printing</h2>
                <h3 className="large-hed">High-quality, portable, and cost-effective roll-up standees for branding</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Retractable Banners for events, trade shows, and promotions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Affordable standee printing price with competitive bulk rates.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional roll-up standee printing with sharp graphics and vibrant colours.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Custom solutions for standee design prices tailored to your branding needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Lightweight, portable, and easy-to-set-up retractable banners.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials for long-term use with fade-resistant prints.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and urgent orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by event organisers, retailers, and corporate brands nationwide.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/retractablebanners.jpg" // Path relative to the public folder
                  alt="Professional printing of retractable banners"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Retractable Banners Delivered On Time</h2>
            <h3 className="small-hed">Focus on your branding while we manage your roll-up standee printing </h3>
            <p>At Printingy, we combine advanced technology and premium materials to deliver exceptional printing of standees and retractable banners. Whether you need standee design price solutions for bulk projects or roll-up standee printing for events, our streamlined process ensures precision and timely delivery.</p>
            <p>We prioritise consistency and quality, guaranteeing visually appealing banners that elevate your brand's message and make a lasting impact.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default RetractableBanners;
